

import { getAssetsQuery, getPublicAssetsQuery } from '../queries';
import { makeRequest, getCurrentUserId } from '../../../../common/utils';






export default async function getAssets(
apiClient,
{ status, assetIds })
{
  const query = getCurrentUserId() ? getAssetsQuery : getPublicAssetsQuery;

  const requestParams = {
    query,
    variables: { status, assetIds },
    context: {
      module: 'assets'
    },
    fetchPolicy: 'network-only'
  };

  const { data, error } = await makeRequest({
    request: apiClient.query,
    requestParams,
    showErrorNotification: true
  });

  if (!data || !data.getAssets && !data.getPublicAssets || error) {
    return assetIds ?
    assetIds.map((assetId) => ({
      assetId,
      assetFiles: { ORIGINAL: { status: 'ERROR' } }
    })) :
    null;
  }

  return data.getAssets || data.getPublicAssets;
}